import { SupportTicketStatusEnum } from '@/services/api-clients';

export function supportTicketStatusColorFilter(status: SupportTicketStatusEnum): string {
  switch (status) {
    case SupportTicketStatusEnum.Open: return 'warning';
    case SupportTicketStatusEnum.InProgress: return 'primary';
    case SupportTicketStatusEnum.Closed: return 'success';
    default: return '';
  }
}
